import { t } from 'i18next';

export const required = t('errors.fieldBlank');
export const pattern = value => ({ value, message: t('errors.filedInvalidFormat') });
export const minValue = value => ({ value, message: t('errors.minValue', { minValue: value }) });
export const maxValue = value => ({ value, message: t('errors.maxValue', { maxValue: value }) });
export const minLength = value => ({ value, message: t('errors.fieldMinLength', { minLength: value }) });
export const maxLength = value => ({ value, message: t('errors.fieldMaxLength', { maxLength: value }) });
